import { Grid, Typography } from '@mui/material';
import { usePqrResponseMedium } from './hook';
import { PqrResponseMediumProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import FieldText from '../../../../../components/general/fields/fieldText';

export const PqrResponseMedium = (props: PqrResponseMediumProps) => {
    const { formik, responseMediums } = usePqrResponseMedium(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Medio de respuesta
                </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
                <AutocompleteField
                    data={formatParams(responseMediums)}
                    label="Medio de respuesta"
                    name="responseMedium"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.responseMedium}
                    errors={formik.errors.responseMedium}
                    value={formik.values.responseMedium}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('responseMedium', value)
                    }
                    disabled={!props.isClousureStatus}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Observación medio de respuesta"
                    name="observation"
                    size="small"
                    required
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                    disabled={!props.isClousureStatus}
                />
            </Grid>
        </Grid>
    );
};
